import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const handleDeleteTemplate = createAsyncThunk("AlertTemplates/handleDeleteTemplate", async (data, thunkAPI) => {
    let templateId=data.id;
    delete data.id
  try {
    const resp = await axios.delete(`${process.env.REACT_APP_BASE_URL}api/alert-templates/${templateId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return {id:templateId};
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
